module.exports = __webpack_public_path__ + "img/benoit4.b3a205a0.jpg";